import { useTranslation } from 'react-i18next';
import type { ICommitRejection } from '@apis/schedule';
import type { TaskId } from '@interfaces/IScheduler';
import styles from './CommitReview.module.css';

interface ICommitRejectionsProps {
  rejections: readonly ICommitRejection[];
  /** Names the refused row — the list form, where several leaves go at once.
   *  Left out by the single review: there, the task is the one on screen. */
  nameOf?: (taskId: TaskId) => string | undefined;
}

/** The server's refusal of a commit, row by row: what to fix before the
 *  promise can be made. Nothing when there was no refusal. */
export function CommitRejections({ rejections, nameOf }: ICommitRejectionsProps) {
  const { t } = useTranslation();
  if (rejections.length === 0) return null;
  const line = (rejection: ICommitRejection) => {
    const reason = t(`scheduler.commit.reason.${rejection.reason}`);
    const name = nameOf?.(rejection.taskId);
    return name ? `${name}: ${reason}` : reason;
  };
  return (
    <div className={`${styles.note} ${styles.bad}`} role="alert" data-testid="commit-rejections">
      {t('scheduler.commit.refused')} {rejections.map(line).join(', ')}
    </div>
  );
}
